<template>
    <div class="br p-t-3 p-b-3 m-t-4 m-b-4 expandable" v-bind:class="{'expandable-open': expanded}">
        <div class="row cu-p p-r-4" v-on:click="toggleExpanded">
            <div class="column">
                <span class="f-s-3 f-w-bold c-primary">{{ trans('Quiz Results') }}</span>
                <span class="c-muted f-s-3 m-l-2">{{ summaryLabel }}</span>
            </div>
            <div>
                <span class="i-container i-filled-dark">
                    <!-- /icons/open-alt.svg -->
                    <svg class="icon icon-expand i-size-small" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M3.664 7.253L2.336 8.747 12 17.338l9.664-8.59-1.328-1.495L12 14.662z" class="icon"/></svg>
                </span>
            </div>
        </div>
        <div v-show="expanded" class="p-l-4 p-r-4 p-t-3">
            <table class="table">
                <thead>
                    <tr>
                        <th class="br-bottom br-c--light c-medium-tint f-w-regular f-s-3">{{ trans('Quiz') }}</th>
                        <th class="br-bottom br-c--light c-medium-tint f-w-regular f-s-3">{{ trans('Status') }}</th>
                        <th class="text-right br-bottom br-c--light c-medium-tint f-w-regular f-s-3">{{ trans('Best Score') }}</th>
                        <th class="text-right br-bottom br-c--light c-medium-tint f-w-regular f-s-3">{{ trans('Attempts') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(result, index) in results" v-bind:key="index">
                        <td v-bind:data-heading="trans('Quiz')">{{ result.title }}</td>
                        <td v-bind:data-heading="trans('Status')" v-bind:class="statusClass(result)">{{ statusLabel(result) }}</td>
                        <td class="text-right" v-bind:data-heading="trans('Best Score')">{{ result.best_score !== null ? result.best_score + '%' : '—' }}</td>
                        <td class="text-right" v-bind:data-heading="trans('Attempts')">{{ result.attempts_count }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        results: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            expanded: false
        }
    },
    computed: {
        passedCount() {
            return this.results.filter((result) => result.passed === true).length;
        },
        summaryLabel() {
            return this.trans(':quizzes Quizzes · :passed Passed', {
                quizzes: this.results.length,
                passed: this.passedCount,
            });
        }
    },
    methods: {
        toggleExpanded() {
            this.expanded = ! this.expanded;
        },
        statusLabel(result) {
            if (result.passed === null) {
                return '—';
            }

            return result.passed ? this.trans('Passed') : this.trans('Failed');
        },
        statusClass(result) {
            if (result.passed === true) {
                return 'c-success';
            }

            if (result.passed === false) {
                return 'c-error';
            }

            return 'c-muted';
        }
    }
}
</script>
